const _header = $('#js-header');
const _menuBtn = $('#js-hamburger');
const _navigation = $('#js-navigation');
const _navItem = _navigation.find('a');
const _navigationBg = $('#js-navigationBg');
const _cta = $('#js-cta');
const _html = $('html');

_menuBtn.click(function() {
	_header.toggleClass('is-open');
	_menuBtn.toggleClass('is-open');
	_navigation.toggleClass('is-open');
	_navigationBg.toggleClass('is-open');
	_cta.toggleClass('is-hidden');
	_html.toggleClass('is-fixed');
});

